export default __webpack_public_path__ + "static/media/redirect.7d8e6f6c.png";